import PropTypes from 'prop-types';

const patientOtherConditionPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
});

export default patientOtherConditionPropType;
